import TrafficTrendChart from "./TrafficTrendChart";

const TrafficTab = ({ timeseries }) => <TrafficTrendChart timeseries={timeseries} />;

export default TrafficTab;
